/* ============================================================================
 *  siteConfig.js — LKV-Treeni
 *  Niche : Laillistettu kiinteistönvälittäjä (LKV-koe) — Keskuskauppakamari (Suomi)
 *  NOTA (ES): Textos en finés. Revisa el Stripe checkoutUrl antes de lanzar.
 * ============================================================================ */

export const siteConfig = {
  saasKey: "lkv-koe-fi",
  brand: {
    name: "LKV-Treeni",
    namePrefix: "LKV",
    nameSuffix: "Treeni",
    subBrand: "by MIVX",
    tagline:
      "Valmennusalustasi Keskuskauppakamarin viralliseen LKV-kokeeseen (laillistettu kiinteistönvälittäjä).",
    flagEmoji: "🇫🇮",
    madeInLabel: "Suomen välityslainsäädäntö",
    locale: "fi-FI",
    timezone: "Europe/Helsinki",
    socialLinks: [],
  },

  niche: {
    professionLabel: "Laillistettu kiinteistönvälittäjä (LKV)",
    aspirantLabel: "LKV-kokelas",
    country: "Suomi",
    authority: "Keskuskauppakamarin välittäjäkoelautakunta",
    phonePlaceholder: "+358 40 123 4567",
    flagshipLaw:
      "Laki kiinteistönvälitysliikkeistä ja vuokrahuoneiston välitysliikkeistä (1075/2000)",
  },

  // Referencia oficial al programa (proof-as-layout) mostrada bajo el H1 del Hero.
  officialReference:
    "Virallinen säädös- ja kirjallisuusluettelo · Keskuskauppakamarin LKV-koe",

  // Labels de los sellos
  sealLabels: {
    verified: "Tarkistettu",
    official: "Virallinen lainsäädäntö",
    source: "Lähde: Keskuskauppakamari / Finlex",
  },

  contact: {
    supportEmail: "go@mivx.com",
    salesEmail: "go@mivx.com",
  },

  payment: {
    checkoutUrl: "https://buy.stripe.com/dRmeVc1Bi7IBfvM69d0co1m", // TODO: URL de Stripe para el dominio LKV
    portalUrl: "",
    cancelSubscriptionEndpoint:
      "https://fgsacxsmkccogatuhofn.supabase.co/functions/v1/cancelar-suscripcion",
    providerName: "Stripe",
  },

  api: {
    geminiModel: "gemini-2.5-flash",
    aiErrorFallback:
      "Yhteys AI-valmentajaan epäonnistui. Yritä hetken kuluttua uudelleen.",
  },

  seo: {
    title: "LKV-koe 2026 — Harjoituskysymykset ja simulaatiot | LKV-Treeni",
    description:
      "Valmistaudu Keskuskauppakamarin viralliseen LKV-kokeeseen. Ajantasainen kysymyspankki, säädösperusteiset selitykset ja aidon kokeen kaltaiset simulaatiot. Aloita ilmaiseksi.",
    hiddenH1:
      "LKV-koe 2026: harjoitustestit laillistetuksi kiinteistönvälittäjäksi",
    hiddenP:
      "Valmennusalusta LKV-kokeeseen: välityslainsäädäntö, asuntokauppa, maakaari, hyvä välitystapa ja koesimulaatiot.",
    keywords:
      "lkv koe, lkv-koe harjoitus, kiinteistönvälittäjä koe, lkv koekysymykset, lkv valmennus, keskuskauppakamari lkv, lvv koe, välittäjäkoe",
    author: "LKV-Treeni",
    domain: "lkvtreeni.fi",
    canonicalUrl: "https://lkvtreeni.fi/",
    ogImage: "/og-image-lkv.png",
    ogTitle: "LKV-Treeni — Harjoituskokeet ja simulaatiot LKV-kokeeseen",
    ogDescription:
      "Vain noin kolmannes läpäisee LKV-kokeen. Harjoittele aidon kokeen kaltaisilla väittämillä ja säädösperusteisilla selityksillä. Aloita ilmaiseksi.",
    schemaCourseName: "LKV-kokeen valmennuskurssi",
    schemaCourseDescription:
      "Interaktiivinen simulaattori ja kysymyspankki Keskuskauppakamarin LKV-kokeeseen (laillistettu kiinteistönvälittäjä).",
  },

  // Colores adaptados al sector inmobiliario nórdico (verdes y azul profundo)
  colors: {
    primary: "#0f766e", // teal-700
    primaryDark: "#115e59", // teal-800
    accent: "#059669", // emerald-600
    primaryTw: "teal-700",
    primaryTwHover: "teal-800",
    primaryTwLight: "teal-50",
    primaryTwBorder: "teal-200",
    primaryTwText: "teal-800",
    secondaryTw: "emerald-600",
    secondaryTwLight: "emerald-50",
    accentTw: "emerald-500",
    gradientFrom: "from-teal-700",
    gradientTo: "to-emerald-500",
  },

  stats: [
    { value: "+700", label: "Väittämää ja kysymystä lainsäädännöstä" },
    { value: "100%", label: "Päivitetty vuoden 2026 säädösluetteloon" },
    { value: "LKV & LVV", label: "Molemmat välittäjäkokeet katettu" },
    { value: "Rajattomasti", label: "Kokeen kaltaisia simulaatioita" },
  ],

  hero: {
    badge: "Simulaattori virallisen kokeen rakenteella",
    titleLine1: "Läpäise",
    titleLine2: "LKV-koe ensimmäisellä yrittämällä",
    subtitle:
      "Vain noin kolmannes kokelaista läpäisee Keskuskauppakamarin LKV-kokeen. Harjoittele aidon kokeen kaltaisilla väittämäsarjoilla, opi säädösperusteiset perustelut jokaiseen vastaukseen ja kysy AI-valmentajalta, kun laki askarruttaa.",
    primaryCta: "Aloita ilmaiseksi",
    secondaryCta: "Kokeile harjoitustestiä",
    secondaryCtaBadge: "Ilmainen",
  },

  features: {
    sectionEyebrow: "Ominaisuudet",
    sectionTitle: "Koko välityslainsäädäntö yhdellä alustalla",
    sectionSubtitle:
      "Suunniteltu nimenomaan LKV-kokeen läpäisyyn: välityslaista ja asuntokauppalaista maakaareen, vuokraukseen, kaavoitukseen ja verotukseen.",
    items: [
      {
        title: "Ajantasainen säädöspohja",
        description:
          "Kysymykset perustuvat Keskuskauppakamarin viralliseen säädösluetteloon: välityslaki, asuntokauppalaki, maakaari, AHVL ja hyvä välitystapa.",
        color: "from-teal-600 to-emerald-500",
        iconKey: "book",
        iconPath:
          "M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253",
      },
      {
        title: "Aidon kokeen simulaattori",
        description:
          "Harjoittele väittämäsarjoilla ja monivalinnoilla aikarajan kanssa — samalla ankaralla logiikalla kuin virallisessa LKV-kokeessa.",
        color: "from-emerald-600 to-teal-500",
        iconKey: "clipboard",
        iconPath:
          "M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z",
      },
      {
        title: "Aihekohtaiset moduulit",
        description:
          "Harjoittele erikseen: asuntokauppa, kiinteistön kauppa, toimeksianto ja hyvä välitystapa, vuokraus, kaavoitus tai verotus.",
        color: "from-teal-500 to-emerald-600",
        iconKey: "target",
        iconPath:
          "M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01",
      },
      {
        title: "Perustellut vastaukset",
        description:
          "Jokainen virhe selitetään viittaamalla oikeaan lakiin ja pykälään — opit, miksi vastaus on oikein, et vain ulkoa.",
        color: "from-emerald-500 to-teal-600",
        iconKey: "bulb",
        iconPath:
          "M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z",
      },
      {
        title: "Edistymisen seuranta",
        description:
          "Näet heti, hallitsetko maakaaren mutta kompastut varainsiirtoveroon. Kohdista harjoittelu heikoimpiin aiheisiin.",
        color: "from-teal-600 to-emerald-400",
        iconKey: "chart",
        iconPath:
          "M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z",
      },
      {
        title: "AI-valmentaja",
        description:
          "Etkö muista, milloin lainhuutoa on haettava tai miten käsiraha eroaa vakiokorvauksesta? Kysy väsymättömältä AI-valmentajalta 24/7.",
        color: "from-emerald-600 to-teal-500",
        iconKey: "spark",
        iconPath: "M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z",
      },
    ],
  },

  demo: {
    sectionEyebrow: "Testaa tasosi heti",
    sectionTitlePart1: "Harjoitustesti",
    sectionTitlePart2: "LKV-kokeeseen",
    sectionSubtitle:
      "Kokeile kokeen tyylisiä kysymyksiä ilman rekisteröitymistä tai maksukorttia.",
    bullets: [
      {
        label: "Virallinen säädöspohja",
        icon: "⚖️",
        iconKey: "document-check",
      },
      { label: "Aikaraja kuten kokeessa", icon: "⏱️", iconKey: "clock" },
      { label: "Välitön arviointi", icon: "📊", iconKey: "chart" },
      { label: "Pykäläkohtaiset selitykset", icon: "💡", iconKey: "bulb" },
    ],
    ctaLabel: "Aloita testi",
    ctaBadge: "ILMAINEN!",
    answerCorrectLabel: "Oikein!",
    answerIncorrectLabel: "Väärä vastaus",
    // Preguntas de demostración (finés) — nivel LKV
    questions: [
      {
        q: "Kuka saa lain mukaan käyttää nimikettä \u201dkiinteistönvälittäjä\u201d tai lyhennettä LKV?",
        o: [
          "Jokainen välitysliikkeessä työskentelevä myyntineuvottelija",
          "Vain henkilö, joka on suorittanut hyväksytysti Keskuskauppakamarin LKV-kokeen",
          "Jokainen, jolla on välitysalan ammattitutkinto",
          "Vain välitysliikkeen toimitusjohtaja",
        ],
        c: 1,
        exp: "Lain mukaan nimikettä kiinteistönvälittäjä tai lyhennettä LKV saa käyttää vain henkilö, joka on suorittanut hyväksytysti välittäjäkoelautakunnan järjestämän LKV-kokeen.",
      },
      {
        q: "Kuinka suurella osalla välitysliikkeen välitystehtäviä suorittavista henkilöistä on oltava LKV-pätevyys?",
        o: [
          "Vähintään puolella (50 %)",
          "Kaikilla (100 %)",
          "Vähintään yhdellä henkilöllä",
          "Vähintään kolmasosalla",
        ],
        c: 0,
        exp: "Vastaavan hoitajan on huolehdittava siitä, että välitysliikkeen jokaisessa toimipaikassa välitystehtäviä suorittavista vähintään puolella on LKV-pätevyys.",
      },
      {
        q: "Missä ajassa lainhuutoa on haettava kiinteistön kaupan jälkeen?",
        o: [
          "Yhden kuukauden kuluessa",
          "Kolmen kuukauden kuluessa",
          "Kuuden kuukauden kuluessa",
          "Vuoden kuluessa",
        ],
        c: 2,
        exp: "Maakaaren mukaan lainhuutoa on haettava kuuden kuukauden kuluessa kauppakirjan tekemisestä. Määräajan ylittäminen korottaa varainsiirtoveroa.",
      },
      {
        q: "Kuinka suuri on varainsiirtovero asunto-osakeyhtiön osakkeiden kaupassa?",
        o: ["4 %", "3 %", "2 %", "1,5 %"],
        c: 3,
        exp: "Vuoden 2024 alusta varainsiirtovero on asunto-osakeyhtiön ja muun kiinteistöyhtiön osakkeista 1,5 % ja kiinteistöistä 3 % kauppahinnasta.",
      },
    ],
  },

  pricing: {
    eyebrow: "Yksi hinta",
    eyebrowTitle1: "Kiinteä kuukausihinta",
    eyebrowTitle2: "Rajaton harjoittelu",
    eyebrowSubtitle:
      "Täysi pääsy LKV- ja LVV-kysymyspankkeihin. Maksat vain niin kauan kuin valmistaudut.",
    stickyNote: "Ei sitoutumista",
    anchorPrice: null,
    reassurance: [
      { label: "Turvallinen maksu Stripella", iconKey: "stripe" },
      { label: "Peruuta milloin tahansa", iconKey: "no-lock" },
      { label: "Välitön pääsy", iconKey: "check" },
    ],
    plan: {
      name: "LKV Pass",
      price: "24,99 €",
      currency: "",
      period: "/kk",
      priceSubtext: "Murto-osa valmennuskurssien hinnasta",
      description:
        "Täysi pääsy kaikkiin aihealueisiin, koesimulaatioihin ja AI-valmentajaan.",
      features: [
        "Ajantasainen kysymyspankki (LKV & LVV)",
        "Selitykset lakiviittauksineen (Finlex)",
        "Kokeen kaltaiset simulaatiot väittämäsarjoineen",
        "AI-valmentaja välityslainsäädäntöön",
        "Aihekohtainen edistymisen seuranta",
        "Etusijalla oleva tuki",
      ],
      ctaLabel: "Aloita valmistautuminen",
      benefitsList: [
        "Simulaatiot virallisen kokeen rakenteella",
        "Rajaton harjoittelu",
        "+700 kysymystä ja väittämää selityksineen",
        "AI-valmentaja käytössä 24/7",
        "Harjoittele puhelimella, tabletilla tai koneella",
        "Virallinen säädösluettelo katettu",
        "Edistymistilastot aiheittain",
        "Etusijalla oleva tuki",
      ],
    },
  },

  faq: {
    eyebrow: "Usein kysytyt kysymykset",
    title: "Vastauksia ennen kuin aloitat",
    subtitle: "Näitä LKV-kokelaat kysyvät meiltä useimmin.",
    items: [
      {
        question:
          "Tarvitsenko välitysalan työkokemusta osallistuakseni LKV-kokeeseen?",
        answer:
          "Et. Keskuskauppakamarin LKV-kokeeseen voi osallistua kuka tahansa — ennakko-opintoja tai työkokemusta ei vaadita, joskin niistä on hyötyä. Koe järjestetään vähintään kaksi kertaa vuodessa.",
      },
      {
        question:
          "Onko kysymyspankki ajan tasalla uusimman säädösluettelon kanssa?",
        answer:
          "Kyllä. Sisältö päivitetään jokaisen kokeen viralliseen säädös- ja kirjallisuusluetteloon, jonka välittäjäkoelautakunta vahvistaa viimeistään kaksi kuukautta ennen koetta.",
      },
      {
        question: "Voinko peruuttaa tilauksen, kun olen läpäissyt kokeen?",
        answer:
          "Tietenkin. Useimmat käyttäjät harjoittelevat 1–3 kuukautta. Voit peruuttaa tilauksen yhdellä klikkauksella omasta paneelistasi, eikä sinulta veloiteta enää mitään.",
      },
      {
        question:
          "Sopiiko alusta myös LVV-kokeeseen (vuokrahuoneiston välittäjä)?",
        answer:
          "Kyllä. Vuokrausta koskeva moduuli (laki asuinhuoneiston vuokrauksesta) ja välityslainsäädännön moduulit kattavat LVV-kokeen keskeisen sisällön.",
      },
      {
        question: "Saanko tältä alustalta virallisen LKV-pätevyyden?",
        answer:
          "Et. LKV-Treeni on valmennussimulaattori. Virallisen kokeen järjestää ja pätevyyden myöntää Keskuskauppakamarin välittäjäkoelautakunta.",
      },
    ],
  },

  platformIncludes: {
    eyebrow: "Simulaattori",
    title: "Kaikki mitä tarvitset läpäisyyn",
    subtitle:
      "Työkalut, joilla LKV-kokeen voi läpäistä ilman turhaa kärsimystä.",
    items: [
      {
        icon: "📚",
        iconKey: "book",
        title: "+700 selitettyä kysymystä",
        description:
          "Emme kerro vain, menikö oikein — selitämme, mikä laki ja pykälä perustelee vastauksen.",
      },
      {
        icon: "⏱️",
        iconKey: "clock",
        title: "Kokeen kaltaiset simulaatiot",
        description:
          "Aikarajalliset harjoituskokeet, jotka totuttavat sinut virallisen kokeen paineeseen ja väittämälogiikkaan.",
      },
      {
        icon: "🏠",
        iconKey: "document-check",
        title: "Käytännön tapaukset",
        description:
          "Kysymyksiä aidoista välitystilanteista: ostotarjoukset, käsirahat, virhevastuu ja toimeksiannon hoito.",
      },
      {
        icon: "📊",
        iconKey: "chart",
        title: "Edistymistutka",
        description:
          "Selkeä kojelauta kertoo, hallitsetko asuntokauppalain mutta maakaari kaipaa vielä kertausta.",
      },
    ],
  },

  trustStrip: [
    { icon: "⚖️", iconKey: "flag", label: "Säädösluettelo 2026" },
    { icon: "🔒", iconKey: "lock", label: "Turvallinen maksu Stripella" },
    {
      icon: "🚫",
      iconKey: "no-lock",
      label: "Ei sitoutumista · Peruutus yhdellä klikkauksella",
    },
    { icon: "🏠", iconKey: "document-check", label: "LKV- ja LVV-kokeet" },
  ],

  howItWorks: {
    eyebrow: "Näin se toimii",
    title: "Kohti LKV-pätevyyttä kolmessa vaiheessa",
    subtitle:
      "Lopeta lakikirjan pänttääminen ilman suuntaa ja ala harjoitella fiksusti.",
    steps: [
      {
        icon: "✨",
        iconKey: "spark",
        title: "Testaa lähtötasosi",
        description:
          "Tee ilmainen harjoitustesti tällä sivulla ja näe heti, missä aiheissa olet vahvoilla.",
      },
      {
        icon: "📝",
        iconKey: "clipboard",
        title: "Luo tili",
        description:
          "Rekisteröidy ilmaiseksi, tutustu aihealueisiin ja ala tallentaa harjoitteluhistoriaasi.",
      },
      {
        icon: "🏆",
        iconKey: "trophy",
        title: "Hanki Premium ja läpäise koe",
        description:
          "Avaa koko simulaattori, lakiviittauksin perustellut selitykset ja AI-valmentaja.",
      },
    ],
  },

  comparison: {
    eyebrow: "Miksi LKV-Treeni",
    title: "Harjoitellen vai onnella kokeeseen?",
    subtitle:
      "Ero itsevarman kokelaan ja kolmatta kertaa yrittävän välillä on harjoittelussa.",
    withLabel: "LKV-Treenillä",
    withoutLabel: "Omin päin",
    rows: [
      {
        label: "Säädökset tiivistettynä ja testattavana",
        withUs: true,
        without: false,
      },
      {
        label: "Aikarajalliset harjoituskokeet",
        withUs: true,
        without: false,
      },
      {
        label: "Perustelu jokaiseen vastaukseen",
        withUs: true,
        without: "Epävarmat keskustelupalstat",
      },
      { label: "Heikkouksien mittaaminen", withUs: true, without: false },
      {
        label: "AI-valmentaja välityslainsäädäntöön",
        withUs: true,
        without: false,
      },
      {
        label: "Vaadittu sijoitus",
        withUs: "24,99 €/kk, ei sopimuksia",
        without: "Valmennuskurssit sadoista euroista",
      },
    ],
  },

  ai: {
    chatTitle: "LKV-Treenin AI-valmentaja",
    welcomeMessage:
      "Hei! Olen välityslainsäädäntöön erikoistunut AI-valmentajasi. Kysy minulta vaikka asuntokauppalain virhevastuusta, maakaaren muotovaatimuksista, käsirahasta tai varainsiirtoverosta.",
    systemInstructionDefault:
      "Olet Suomen kiinteistönvälitysalan lainsäädännön asiantuntija ja valmennat käyttäjiä Keskuskauppakamarin LKV-kokeeseen. Tunnet erityisesti lain kiinteistönvälitysliikkeistä ja vuokrahuoneiston välitysliikkeistä (1075/2000), välityslain (1074/2000), asuntokauppalain (843/1994), maakaaren (540/1995), lain asuinhuoneiston vuokrauksesta (481/1995), hyvän välitystavan ohjeen, kaavoitus- ja rakentamislainsäädännön sekä varainsiirto- ja luovutusvoittoverotuksen ja rahanpesulain velvoitteet. Vastaa suomeksi (fi-FI) tiiviisti ja täsmällisesti. Älä keksi pykäliä tai tietoja.",
    systemInstructionTutor:
      "Olet kokenut LKV-valmentaja, joka auttaa kokelaita läpäisemään Keskuskauppakamarin välittäjäkokeen. Olet suora, selkeä ja opettavainen. Kun selität säännön, mainitse mahdollisuuksien mukaan laki ja pykälä. Vastaa suomeksi (fi-FI).",
    casePromptTemplate: (topicTitle) =>
      `Laadi lyhyt käytännön tapaus (enintään 100 sanaa) aiheesta "${topicTitle}", jossa kiinteistönvälittäjä hoitaa toimeksiantoa Suomessa. Kysy, mikä olisi lain ja hyvän välitystavan mukainen toimintatapa.`,
    caseSystemInstruction:
      "Olet Keskuskauppakamarin välittäjäkoelautakunnan kokenut kysymyslaatija.",
    inputPlaceholder: "Kirjoita kysymyksesi laista tai välitystoiminnasta...",
  },

  exam: {
    simulatorQuestions: 60, // Harjoitussimulaatio: 60 kysymystä
    simulatorDurationMinutes: 120,
    // IDs sincronizados con src/constants/temario.js (t1–t7)
    topicWeights: [
      { id: "t1", weight: 0.2 }, // Välityslainsäädäntö ja toimeksianto
      { id: "t2", weight: 0.15 }, // Asuntokauppa
      { id: "t3", weight: 0.15 }, // Kiinteistön kauppa (maakaari)
      { id: "t4", weight: 0.2 }, // Hyvä välitystapa
      { id: "t5", weight: 0.1 }, // Vuokraus
      { id: "t6", weight: 0.1 }, // Kaavoitus ja kiinteistönmuodostus
      { id: "t7", weight: 0.1 }, // Verotus, rahanpesu ja arviointi
    ],
    passingScore: 50, // LKV-kokeessa läpäisyyn vaaditaan n. puolet maksimipisteistä
    simulatorTitle: "LKV-harjoituskoe",
    exitModal: {
      title: "Keskeytetäänkö koe?",
      lead: "Vastauksesi menetetään!",
      warning:
        "Merkitsemiäsi vastauksia ei tallenneta, ja joudut aloittamaan harjoituskokeen alusta.",
      confirmLabel: "Kyllä, keskeytä",
      cancelLabel: "Jatka koetta",
      footnote: "Edistymisesi nollautuu, jos poistut nyt",
      closeLabel: "Sulje",
    },
  },

  uiCopy: {
    loading: "Ladataan...",
    ready: "Valmiina",
    navHome: "Etusivu",
    navStudy: "Lainsäädäntö",
    navStudyShort: "Aiheet",
    navQuizzes: "Aihemoduulit",
    navQuizzesShort: "Moduulit",
    navSimulator: "Harjoituskoe",
    navBilling: "Tilaukseni",
    sidebarPrincipal: "Yleiskatsaus",
    sidebarSimulation: "Simulaatio",
    bannerCta: "🎓 Avaa täydet harjoituskokeet ja varmista LKV-pätevyytesi",
    bannerCtaButton: "Premium",
    legalLastUpdate: "Viimeksi päivitetty: 15.1.2026",
    cta: {
      finalSectionTitle: "Valmis hankkimaan LKV-pätevyyden?",
      finalSectionSubtitle:
        "Valmistaudu Keskuskauppakamarin kokeeseen yli 700 kysymyksellä koko säädösluettelosta. Aloita tänään.",
      finalSectionPrimary: "Aloita valmistautuminen",
      finalSectionSecondary: "Ota yhteyttä tukeen",
      finalSectionFooter: "✨ Välitön pääsy · Peruuta milloin tahansa",
      contactModalTitle: "Asiakastuki",
      contactModalSubtitle: "Onko jokin epäselvää? Kirjoita meille suoraan:",
      contactModalClose: "Sulje ikkuna",
      contactModalCloseAriaLabel: "Sulje",
    },
    masterDomainLabel: "Välityslainsäädännön hallinta",
    statsCards: {
      generalProgress: "Kokonaisedistyminen",
      sectionsRead: "Suoritetut moduulit",
      examsTaken: "Harjoituskokeet",
      bestScore: "Paras tulos",
    },
    auth: {
      welcomeTitle: "Tervetuloa takaisin",
      welcomeSubtitle: "Kirjaudu sisään jatkaaksesi harjoittelua",
      registerTitle: "Luo tili",
      registerSubtitle: "Ota ensimmäinen askel kohti LKV-pätevyyttä",
    },
    landing: {
      productNavLabel: "Alusta",
      productLinks: [
        { href: "#features", label: "Ominaisuudet" },
        { href: "#pricing", label: "Hinnat" },
        { href: "#demo", label: "Ilmainen testi" },
        { href: "#testimonials", label: "Kokemuksia" },
      ],
    },
  },

  // ==========================================================================
  //  LEGALCOPY — Todo el texto legal del sitio (Käyttöehdot / Tietosuoja / Huomautus)
  //  Marcadores disponibles: {{company}} {{operator}} {{operatorLocation}}
  //                          {{domain}} {{email}} {{price}} {{provider}} {{law}}
  //  Para clonar a otro idioma: traducir SOLO este bloque.
  // ==========================================================================
  legalCopy: {
    pageEyebrow: "Oikeudelliset tiedot",
    pageTitleLine1: "Oikeudelliset",
    pageTitleLine2: "tiedot",
    tablistLabel: "Oikeudelliset asiakirjat",
    backHome: "Takaisin etusivulle",
    tabs: {
      notice: "Oikeudellinen huomautus",
      terms: "Käyttöehdot",
      privacy: "Tietosuojaseloste",
    },

    notice: {
      s1Title: "Palvelun ylläpitäjä",
      s1TextBefore: "Palvelua {{company}} (osoitteessa",
      s1TextAfter:
        ") ylläpitää ja siitä vastaa {{operator}}, ranskalaisen oikeuden mukainen yksinkertaistettu osakeyhtiö (SAS), kotipaikka {{operatorLocation}}.",
      s2Title: "Julkaisusta vastaava",
      s2Text: "Julkaisusta vastaa {{operator}} -yhtiön laillinen edustaja.",
      s3Title: "Yhteystiedot",
      s3Text:
        "Oikeudellisissa, teknisissä ja kaupallisissa kysymyksissä voit ottaa yhteyttä sähköpostitse:",
      s4Title: "Palvelinisännöinti ja tekniset toimittajat",
      s4Text:
        "Palvelu toimii ulkopuolisten palveluntarjoajien infrastruktuurissa (mm. sovellusalusta, tietokanta ja maksunvälitys). Maksut käsittelee {{provider}}; {{company}} ei tallenna maksukorttitietoja.",
      s5Title: "Verkkovälitteinen riidanratkaisu (EU)",
      s5Text:
        "Asetuksen (EU) N:o 524/2013 mukaisesti Euroopan komissio tarjoaa kuluttajille verkkovälitteisen riidanratkaisualustan:",
      s6Title: "Tavaramerkki",
      s6Text:
        "{{company}} on {{operator}} -yhtiön ylläpitämä kaupallinen tuotenimi.",
    },

    terms: {
      sections: [
        {
          title: "Ehtojen hyväksyminen",
          paragraphs: [
            {
              text: "Käyttämällä palvelua {{company}} käyttäjä hyväksyy nämä käyttöehdot kokonaisuudessaan. Jos et hyväksy ehtoja, älä käytä palvelua.",
            },
          ],
        },
        {
          title: "Palvelun kuvaus",
          paragraphs: [
            {
              text: "{{company}} on itsenäinen koulutuspalvelu, joka tarjoaa harjoituskysymyksiä, harjoituskokeita ja opiskelumateriaalia kokeeseen valmistautumista varten. Palvelu ei ole viranomainen eikä sillä ole yhteyttä kokeen järjestäjään.",
            },
          ],
        },
        {
          title: "Palvelun sallittu käyttö",
          paragraphs: [
            {
              text: "Käyttäjä sitoutuu käyttämään palvelua ainoastaan henkilökohtaisiin opiskelutarkoituksiin. Sisällön kopiointi, jakelu, jälleenmyynti tai julkaiseminen ilman lupaa on kiellettyä. Käyttöoikeus on henkilökohtainen eikä tunnuksia saa luovuttaa kolmannelle.",
            },
          ],
        },
        {
          title: "Tilin rekisteröinti",
          paragraphs: [
            {
              text: "Osa toiminnoista edellyttää tilin luomista. Käyttäjän on annettava oikeat ja ajantasaiset tiedot sekä huolehdittava tunnustensa säilyttämisestä. Käyttäjä vastaa kaikesta tunnuksillaan tapahtuvasta toiminnasta.",
            },
          ],
        },
        {
          title: "Hinnat ja laskutus",
          paragraphs: [
            {
              text: "Premium-tilauksen hinta on {{price}} (tai etusivulla kulloinkin ilmoitettu hinta). Tilaamalla käyttäjä hyväksyy automaattisen kuukausiveloituksen. {{company}} voi muuttaa hintoja ilmoittamalla muutoksesta etukäteen rekisteröityyn sähköpostiosoitteeseen.",
            },
            {
              text: "Maksut käsittelee {{provider}}. {{company}} ei tallenna maksukorttitietoja.",
            },
          ],
        },
        {
          title: "Peruutus- ja palautuskäytäntö",
          paragraphs: [
            {
              strong: "Peruutus:",
              text: "Käyttäjä voi peruuttaa tilauksensa milloin tahansa asetuksistaan. Peruutuksen jälkeen käyttöoikeus jatkuu jo maksetun laskutuskauden loppuun, eikä uusia veloituksia tehdä.",
            },
            {
              strong: "Ei palautuksia:",
              text: "Maksettuja maksuja ei palauteta osittain eikä kokonaan sen jälkeen, kun maksu on käsitelty, ellei pakottavasta kuluttajansuojalainsäädännöstä muuta johdu.",
            },
            {
              strong: "Peruuttamisoikeus (EU):",
              text: "Kuluttajalla on lähtökohtaisesti 14 päivän peruuttamisoikeus. Koska kyseessä on välittömästi toimitettava digitaalinen palvelu, käyttäjä pyytää palvelun välitöntä toimittamista ja hyväksyy tilausta tehdessään, että peruuttamisoikeus raukeaa käyttöoikeuden alkaessa.",
            },
          ],
        },
        {
          title: "Ei takuuta kokeen läpäisemisestä",
          paragraphs: [
            {
              text: "{{company}} on opiskelun tukiväline. Emme takaa kokeen läpäisemistä. Tulos riippuu käyttäjän omasta valmistautumisesta ja suorituksesta.",
            },
          ],
        },
        {
          title: "Oikeudellinen huomautus ja tietolähteet",
          paragraphs: [
            {
              text: "Sisältö perustuu julkisiin lähteisiin ja voimassa olevaan lainsäädäntöön, ja se on laadittu huolellisesti. Emme kuitenkaan takaa sisällön virheettömyyttä tai ajantasaisuutta emmekä vastaa sisältöön luottamisesta aiheutuvista seurauksista. Virallinen ja sitova tieto on aina tarkistettava kokeen järjestäjältä ja ajantasaisesta lainsäädännöstä.",
            },
            {
              text: "Palvelun harjoituskysymykset ovat itse laadittuja. Ne eivät ole virallisia koekysymyksiä eikä palvelu ole kokeen järjestäjän hyväksymä tai sen kanssa yhteydessä.",
            },
          ],
        },
        {
          title: "Vastuunrajoitus",
          paragraphs: [
            {
              text: "{{company}} ei vastaa välillisistä vahingoista, saamatta jääneestä voitosta eikä palvelun käyttökatkoksista. Vastuu rajoittuu enintään käyttäjän viimeisen kahdentoista kuukauden aikana maksamaan määrään, ellei pakottavasta lainsäädännöstä muuta johdu.",
            },
          ],
        },
        {
          title: "Tilin jäädyttäminen tai sulkeminen",
          paragraphs: [
            {
              text: "{{company}} voi jäädyttää tai sulkea tilin, jos näitä ehtoja rikotaan, esimerkiksi tunnusten jakamisen tai sisällön luvattoman levittämisen vuoksi.",
            },
          ],
        },
        {
          title: "Palvelun muutokset",
          paragraphs: [
            {
              text: "Palvelun sisältöä ja toimintoja voidaan kehittää ja muuttaa. Olennaisista muutoksista ilmoitetaan käyttäjille.",
            },
          ],
        },
        {
          title: "Sovellettava laki",
          paragraphs: [
            {
              text: "Näihin ehtoihin sovelletaan Suomen lakia siltä osin kuin kuluttajaa suojaava pakottava lainsäädäntö sitä edellyttää. Kuluttaja voi saattaa riidan kuluttajariitalautakunnan käsiteltäväksi tai nostaa kanteen kotipaikkansa käräjäoikeudessa.",
            },
          ],
        },
      ],
    },

    privacy: {
      sections: [
        {
          title: "Johdanto",
          paragraphs: [
            {
              text: "Tässä selosteessa kerrotaan, miten {{company}} käsittelee henkilötietoja EU:n yleisen tietosuoja-asetuksen (GDPR) mukaisesti.",
            },
          ],
        },
        {
          title: "Rekisterinpitäjä",
          paragraphs: [
            {
              text: "Rekisterinpitäjä on {{operator}}, kotipaikka {{operatorLocation}}. Tietosuoja-asioissa voit ottaa yhteyttä osoitteeseen:",
            },
          ],
          contactEmail: true,
        },
        {
          title: "Keräämämme tiedot",
          paragraphs: [
            {
              text: "Keräämme vain palvelun toiminnan kannalta tarpeelliset tiedot: nimi, sähköpostiosoite, mahdollinen puhelinnumero, opiskelun edistyminen, harjoituskokeiden tulokset sekä tilaustiedot.",
            },
          ],
        },
        {
          title: "Tietojen käyttö",
          paragraphs: [
            {
              text: "Käytämme tietoja käyttäjätilien hallintaan, opiskelun edistymisen näyttämiseen, palvelun kehittämiseen, asiakastukeen sekä tilausten ja maksujen hallinnointiin. Emme myy henkilötietoja kolmansille.",
            },
          ],
        },
        {
          title: "Käsittelyn oikeusperuste",
          paragraphs: [
            {
              text: "Käsittelyn perusteena on sopimuksen täytäntöönpano (käyttäjätili ja tilaus), lakisääteiset velvoitteet (kirjanpito) sekä oikeutettu etu (palvelun kehittäminen ja tietoturva).",
            },
          ],
        },
        {
          title: "Tietojen luovuttaminen",
          paragraphs: [
            {
              text: "Tietoja luovutetaan vain palvelun toiminnan edellyttämille käsittelijöille, kuten palvelinisännöinnin, tietokannan ja maksunvälityksen tarjoajille, jotka käsittelevät tietoja lukuumme ja ohjeidemme mukaisesti.",
            },
          ],
        },
        {
          title: "Tietoturva",
          paragraphs: [
            {
              text: "Käytämme teknisiä ja organisatorisia suojatoimia, kuten salattua tiedonsiirtoa ja pääsynhallintaa, suojataksemme tiedot luvattomalta pääsyltä, häviämiseltä ja muuttamiselta.",
            },
          ],
        },
        {
          title: "Rekisteröidyn oikeudet",
          paragraphs: [
            {
              text: "Sinulla on oikeus saada pääsy tietoihisi, oikaista ja poistaa ne, rajoittaa ja vastustaa käsittelyä sekä siirtää tiedot järjestelmästä toiseen. Voit myös peruuttaa antamasi suostumuksen. Sinulla on oikeus tehdä valitus tietosuojavaltuutetun toimistolle.",
            },
          ],
        },
        {
          title: "Tietojen säilytys",
          paragraphs: [
            {
              text: "Säilytämme henkilötietoja vain niin kauan kuin se on tarpeen palvelun tarjoamiseksi tai lakisääteisten velvoitteiden täyttämiseksi. Tämän jälkeen tiedot poistetaan tai anonymisoidaan.",
            },
          ],
        },
        {
          title: "Evästeiden käyttö",
          paragraphs: [
            {
              text: "Palvelu voi käyttää evästeitä ja vastaavia tekniikoita kirjautumisen ylläpitämiseen, asetusten muistamiseen ja käytön analysointiin. Voit hallita evästeitä selaimesi asetuksista.",
            },
          ],
        },
        {
          title: "Muutokset selosteeseen",
          paragraphs: [
            {
              text: "Selostetta voidaan päivittää. Olennaisista muutoksista ilmoitetaan palvelussa tai sähköpostitse.",
            },
          ],
        },
      ],
    },
  },

  legal: {
    companyName: "LKV-Treeni by MIVX",
    companyShortName: "LKV-Treeni",
    governingLaw: "Suomi",
    privacyContactEmail: "go@mivx.com",
    operatorName: "PAUL BREMOND SAS",
    operatorLocation: "Pariisi, Ranska",
  },
};

export default siteConfig;
